// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询任务列表
 * @returns {*}
 */
export function listFirewall(instanceCode) {
  return axios.get('/tencent/lightHouse/firewall/list?instanceCode=' + instanceCode).then(res => res.data);
}
/**
 * 根据id修改状态
 * @returns {*}
 */
export function addFirewall(port, instanceCode) {
  return axios.get('/tencent/lightHouse/firewall/add/' + port + '?instanceCode=' + instanceCode).then(res => res.data);
}
/**
 * 获取实例列表
 * @returns {*}
 */
export function listInstance() {
  return axios.get('/tencent/lightHouse/listInstance').then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/tencent.js